<div id="wrap" *ngIf="chartData?.primaryChartSeriesData">
  <div class="col-xs-12 col-sm-12 col-md-6 col-xl-6" id="chart-year">
    <apx-chart #chart [series]="chartOptions?.series!" [chart]="chartOptions.chart!"
      [dataLabels]="chartOptions.dataLabels!" [plotOptions]="chartOptions.plotOptions!" [yaxis]="chartOptions.yaxis!"
      [xaxis]="chartOptions.xaxis!" [subtitle]="chartOptions.subtitle!" [colors]="chartColors"
      [states]="chartOptions.states!" [title]="chartOptions.title!" [tooltip]="chartOptions.tooltip!"></apx-chart>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-6 col-xl-6" id="chart-quarter" *ngIf="chartQuarterOptions">
    <apx-chart [series]="chartQuarterOptions?.series!" [chart]="chartQuarterOptions.chart!"
      [legend]="chartQuarterOptions.legend!" [plotOptions]="chartQuarterOptions.plotOptions!"
      [yaxis]="chartQuarterOptions.yaxis!" [xaxis]="chartQuarterOptions.xaxis!" [grid]="chartQuarterOptions.grid!"
      [title]="chartQuarterOptions.title!"></apx-chart>
  </div>
</div>